import { createStoreConfig } from '../store';

const store = createStoreConfig();

export const useConfig = () => {
  return {
    store,
  };
};
